"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeable = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var button_1 = require("../../button");
var inject_props_if_target_not_existed_1 = require("../util/inject-props-if-target-not-existed");
var fallbackColumnKey = "__removeable_addon__";
var rowDisabled = null;
function removeable(_a) {
    var _b = _a.onRemove, onRemove = _b === void 0 ? function () { return null; } : _b, _c = _a.width, width = _c === void 0 ? 46 : _c, targetColumnKey = _a.targetColumnKey, _d = _a.icon, icon = _d === void 0 ? "dismiss" : _d, _e = _a.render, render = _e === void 0 ? function (x) { return x; } : _e;
    return {
        getInfo: function () { return ({ name: "removeable" }); },
        onInjectProps: function (props) {
            var columns = props.columns;
            rowDisabled = props.rowDisabled || (function () { return false; });
            columns = inject_props_if_target_not_existed_1.injectPropsIfTargetNotExisted(columns, targetColumnKey, {
                key: fallbackColumnKey,
                width: width,
                header: null,
                render: function () { return null; },
            }, true);
            return tslib_1.__assign(tslib_1.__assign({}, props), { columns: columns });
        },
        onInjectColumn: function (previous) { return function (record, rowKey, recordIndex, column, columnIndex) {
            // 不是目标列
            if (column.key !== fallbackColumnKey) {
                return previous(record, rowKey, recordIndex, column, columnIndex);
            }
            var _a = previous(record, rowKey, recordIndex, column, columnIndex), preChildren = _a.children, props = _a.props, result = tslib_1.__rest(_a, ["children", "props"]);
            var children = preChildren;
            // 非表头
            if (recordIndex !== -1 && !rowDisabled(record)) {
                var element = react_1.default.createElement(button_1.Button, { type: "icon", icon: icon, htmlType: "button" });
                children = (react_1.default.createElement("div", { onClick: function (event) { return onRemove(rowKey, { event: event, record: record }); } }, render(element, {
                    children: preChildren,
                    record: record,
                    rowKey: rowKey,
                    recordIndex: recordIndex,
                    disabled: rowDisabled(record),
                })));
            }
            return tslib_1.__assign(tslib_1.__assign({}, result), { props: props, children: children });
        }; },
    };
}
exports.removeable = removeable;
//# sourceMappingURL=removeable.js.map